import Link from "next/link"
import type { ReactNode } from "react"
import { ArrowLeft, Headset, House, LifeBuoy, LogIn, Newspaper, PackageOpen, RotateCw, type LucideIcon } from "lucide-react"
import type { IkonAksi } from "@/modules/sistem/domain/halaman"
import { cn } from "@/shared/lib/utils"

const IKON: Record<IkonAksi, LucideIcon> = {
  beranda: House,
  bantuan: LifeBuoy,
  blog: Newspaper,
  kontak: Headset,
  paket: PackageOpen,
  "muat-ulang": RotateCw,
  kembali: ArrowLeft,
  masuk: LogIn,
}

interface TombolBulatProps {
  ikon: IkonAksi
  label: string
  utama?: boolean
  href?: string
  onClick?: () => void
  nonaktif?: boolean
  isi?: ReactNode
}

export function TombolBulat({ ikon, label, utama = false, href, onClick, nonaktif = false, isi }: TombolBulatProps) {
  const Ikon = IKON[ikon]
  const luar = cn(
    "group inline-flex rounded-full border border-border bg-card p-1 shadow-md transition-all",
    nonaktif ? "opacity-60" : "hover:-translate-y-0.5 hover:shadow-lg active:translate-y-0",
  )
  const dalam = cn(
    "flex h-11 w-11 items-center justify-center rounded-full text-sm font-bold tabular-nums transition-transform",
    "bg-primary text-primary-foreground",
    !nonaktif && "group-hover:scale-95",
  )
  const konten = <span className={dalam}>{isi ?? <Ikon className="h-[1.15rem] w-[1.15rem]" aria-hidden="true" />}</span>

  if (href) {
    return (
      <Link href={href} aria-label={label} title={label} className={luar}>
        {konten}
      </Link>
    )
  }

  return (
    <button type="button" onClick={onClick} disabled={nonaktif} aria-label={label} title={label} className={luar}>
      {konten}
    </button>
  )
}
